import ScriptModel from '@src/initialize/inject-scripts/libs/script-model';
import deviceUtils from '@src/utils/device-utils';
import dailyWebviewComm from '../../utils/daily-webview-comm';

export const weinre = new ScriptModel({
  condition: ~window.location.search.indexOf('__DEBUG__'),
  script: 'http://npm-registry.seasungame.com:10001/target/target-script-min.js#anonymous'
});

// export const jsconsole = new ScriptModel({
//   condition: ~window.location.search.indexOf('__JSCONSOLE__'),
//   script: `https://npm-registry.seasungame.com:10004/js/remote.js?${window.location.search.indexOf('__JSCONSOLE__')}`
// });

export const vconsole = new ScriptModel({
  condition: ~window.location.search.indexOf('__VCONSOLE__'),
  script: 'https://npm-registry.seasungame.com/xfe-static/libs/vconsole/3.1.1/vconsole.min.js',
  resolve: () => {
    new window.VConsole();
    const reload = () => {
      window.removeEventListener('load', reload);
      document.querySelector('#__vconsole .vc-cmd-input').value = 'window.location["reload"]()';
    };
    window.addEventListener('load', reload);
  }
});

/**
 * 拦截 jsonp 并输入 console.log
 */
export const interceptJsonp = new ScriptModel({
  condition: ~window.location.search.indexOf('__INTERCEPT_JSONP__'),
  // 允许外网, 内部代码目前使用 console.log 的形式, 问题不大
  script: '//zhcdn01.xoyo.com/xassets/lib/intercept-jsonp/0.0.1/index.es6.js'
});

/**
 * 百度统计
 * @type {ScriptModel}
 * @private
 */
export const internalConcreteNavConfig = new ScriptModel({
  condition: ~window.location.search.indexOf('__NAV__'),
  script: ['internal-access---concrete-nav-config.js', '//zhcdn01.xoyo.com/xassets/lib/concrete-nav/0.0.x/concrete-nav.umd.js'],
  resolve: () => {
    window.concreteNav(window.INTERNAL_CONCRETE_NAV_CONFIG);
  }
});

/**
 * 百度统计
 * @type {ScriptModel}
 * @private
 */
export const baiduStatistic = new ScriptModel({
  condition: !!process.env.BAIDU_STATISTIC_ACCOUNT,
  script: `//hm.baidu.com/hm.js?${process.env.BAIDU_STATISTIC_ACCOUNT}`,
  prepare: () => (window['_hmt'] = window['_hmt'] || [])
});

/**
 * 751Code统计
 * @type {ScriptModel}
 * @private
 */
export const _751CodeStatistic = new ScriptModel({
  script: '//zhcdn01.xoyo.com/xassets/lib/751code/https/o_code.js'
});

// noinspection SpellCheckingInspection
/**
 * 通用统计 - 不添加底部 footer ui
 * WARNING: footer 仅允许存在有且只有一个
 * @type {ScriptModel}
 */
export const commonStatistic = new ScriptModel({
  script: '//zhcdn01.xoyo.com/xassets/lib/footer-track/0.0.x/footer-track.umd.js'
});

/**
 * 推栏图片长按保存
 * @type {ScriptModel}
 */
export const saveDailyImageWhenLongPress = new ScriptModel({
  condition: deviceUtils.isJianghuDaily(),
  script: '//zhcdn01.xoyo.com/xassets/lib/long-press-event/2.4.4/long-press-event.min.js',
  resolve: () => {
    document.addEventListener('long-press', function(e) {
      if (e.target && e.target.tagName === 'IMG' && typeof e.target.src === 'string') {
        const src = e.target.src;
        if (/^https?:/.test(src) || src.startsWith('data:image')) {
          dailyWebviewComm.saveImage(e.target.src);
        }
      }
    });
  }
});

/**
 * 通用统计 - 添加底部 footer ui
 * WARNING: footer 仅允许存在有且只有一个
 * @type {ScriptModel}
 */
// export const commonStatistic = new ScriptModel({
//   async custom(loder) {
//     if (!window.$) {
//       loder.add('jquery-1.7.2', await loder.loadScript('//zhcdn01.xoyo.com/xassets/lib/jquery/1.7.2/jquery.min.js'));
//     }
//     loder.add('xfe-footer', await loder.loadScript('//zhcdn01.xoyo.com/xassets/com/pf/footer/v2/black/m/footer.js'));
//   }
// });
